import React from "react";
import popupsyle from "../../style/PopUp.module.css";
import { TfiClose } from "react-icons/tfi";
import FallbackAvatar from "../../components/ui/FallbackAvatar/FallbackAvatar";

const GroupPeopleView = ({ show, onClose, data }) => {
  if (!show) return null;
  const apiUrl = process.env.REACT_APP_API_URL;

  return (
    <div className={popupsyle.popupBackground}>
      <div className={popupsyle.popupPeopleView}>
        <div className={popupsyle.PopupContainer}>
          <div className={popupsyle.popupHeader}>
            <h3>{`${data.group_name}`}</h3>
            {/* <button onClick={onClose} className={popupsyle.closeButton}>
            ×
          </button> */}
            <TfiClose onClick={onClose} />
            {/* <div className={popupsyle.buttonClose}>x</div> */}
          </div>
          <div className={popupsyle.popupContent}>
            <h3
              className={popupsyle.headingColor}
              style={{ margin: "0", marginBottom: "10px" }}
            >
              {data.Field}
            </h3>
            {data.peopleList.map((emp, index) => (
              <div className={popupsyle.popupPeopleViewDiv}>
                <ImageWithFallback
                  src={`${apiUrl}${emp.emp_pic}`}
                  alt={`${emp.first_name} ${emp.last_name}`}
                  name={`${emp.first_name} ${emp.last_name}`}
                />
                <p
                  className={popupsyle.PeopleName}
                  style={{ fontSize: "14px" }}
                >{`${emp.first_name} ${emp.last_name}`}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
const ImageWithFallback = ({ src, alt, name }) => {
  const [imgError, setImgError] = React.useState(false);

  return !imgError ? (
    <img
      src={src}
      onError={() => setImgError(true)}
      alt={alt}
      className={popupsyle.popupPeopleViewIcon}
    />
  ) : (
    <FallbackAvatar name={name} size={30} />
  );
};

export default GroupPeopleView;
